import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://pvdoelqyvwxwhwahllvn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB2ZG9lbHF5dnd4d2h3YWhsbHZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA4NDI0NTMsImV4cCI6MjA2NjQxODQ1M30.-5_e0q3eveGIBTwi8KSuk6lEEiQux_1H4jfpwSaxnO0';

// Supabase auth storage key - used to clear auth state properly
export const SUPABASE_AUTH_STORAGE_KEY = 'fahim_auth';

// Check if Supabase is configured with valid credentials
export const isSupabaseConfigured = 
  SUPABASE_URL !== 'https://<PROJECT-ID>.supabase.co' && 
  SUPABASE_ANON_KEY !== '<ANON_KEY>';

// Throw error only when attempting to use an unconfigured client
if(!isSupabaseConfigured){
  console.warn('Supabase is not configured with valid credentials. Using fallback storage.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { 
    persistSession: true,
    autoRefreshToken: true,
    storageKey: SUPABASE_AUTH_STORAGE_KEY
  }
});

// Helper function to check auth status
export const checkAuthStatus = async () => {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.error('Error checking auth status:', error);
      return null;
    }
    return data.session;
  } catch (error) {
    console.error('Error in auth check:', error);
    return null;
  }
};

// Helper function to completely clear auth state
export const clearAuthState = () => {
  try {
    // Clear Supabase auth from localStorage
    localStorage.removeItem(SUPABASE_AUTH_STORAGE_KEY);
    
    // Clear other auth-related items
    localStorage.removeItem('fahim_user');
    
    // Clear any session cookies
    document.cookie.split(';').forEach(cookie => {
      document.cookie = cookie
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });
    
    console.log('Auth state cleared successfully');
    return true;
  } catch (error) {
    console.error('Error clearing auth state:', error);
    return false;
  }
};